import { Tag } from '@spectrum-web-components/tags';
import styles from './tag.lit.scss';

Object.defineProperty(Tag, 'styles', {
  value: [...Tag.styles, styles],
  writable: false,
});
customElements.define('sp-tag', Tag);
